"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeprecatedThemeParameterMap = exports.EmptyThemeParameterMap = exports.DefaultLeapLifeTheme = exports.DefaultFionaTheme = exports.DefaultEvenTheme = exports.ThemeColor = exports.LeapLifeDefaultFonts = exports.FionaDefaultFonts = exports.FontFamily = void 0;
var FontFamily;
(function (FontFamily) {
    FontFamily["Arial"] = "Arial";
    FontFamily["ArialBlack"] = "Arial Black";
    FontFamily["Cabin"] = "Cabin";
    FontFamily["Courier"] = "Courier";
    FontFamily["CourierNew"] = "Courier New";
    FontFamily["FrankRuhlLibre"] = "Frank Ruhl Libre";
    FontFamily["Geneva"] = "Geneva";
    FontFamily["Helvetica"] = "Helvetica";
    FontFamily["Impact"] = "Impact";
    FontFamily["Lato"] = "Lato";
    FontFamily["Lora"] = "Lora";
    FontFamily["LucidaConsole"] = "Lucida Console";
    FontFamily["LucidaGrande"] = "Lucida Grande";
    FontFamily["LucidaSansUnicode"] = "Lucida Sans Unicode";
    FontFamily["Merriweather"] = "Merriweather";
    FontFamily["Monaco"] = "Monaco";
    FontFamily["Montserrat"] = "Montserrat";
    FontFamily["NotoSans"] = "Noto Sans";
    FontFamily["Nunito"] = "Nunito";
    FontFamily["OpenSans"] = "Open Sans";
    FontFamily["Oswald"] = "Oswald";
    FontFamily["PTSans"] = "PT Sans";
    FontFamily["Raleway"] = "Raleway";
    FontFamily["Roboto"] = "Roboto";
    FontFamily["RobotoCondensed"] = "Roboto Condensed";
    FontFamily["Rubik"] = "Rubik";
    FontFamily["SourceSansPro"] = "Source Sans Pro";
    FontFamily["Tahoma"] = "Tahoma";
    FontFamily["TrebuchetMS"] = "Trebuchet MS";
    FontFamily["Verdana"] = "Verdana";
})(FontFamily = exports.FontFamily || (exports.FontFamily = {}));
exports.FionaDefaultFonts = {
    BrandonGrotesque: 'BrandonGrotesque',
    BrandonText: 'BrandonText',
};
exports.LeapLifeDefaultFonts = {
    Nunito: 'Nunito',
    Roboto: 'Roboto',
};
var ThemeColor;
(function (ThemeColor) {
    ThemeColor["black"] = "#000000";
    ThemeColor["blue"] = "#3366cc";
    ThemeColor["green"] = "#0bb89b";
    ThemeColor["red"] = "#e64f86";
    ThemeColor["white"] = "#ffffff";
    ThemeColor["gray3"] = "#f3f3f3";
    ThemeColor["gray5"] = "#d9d9d9";
    ThemeColor["gray7"] = "#707070";
    ThemeColor["gray9"] = "#434343";
    ThemeColor["gray11"] = "#222222";
})(ThemeColor = exports.ThemeColor || (exports.ThemeColor = {}));
const DefaultTheme = {
    borderRadiusLarge: '14px',
    borderRadiusSmall: '5px',
    colorBackgroundPrimary: ThemeColor.white,
    colorBorder: '#e2e5e9',
    colorTextPrimary: '#323232',
    colorTextSecondary: '#767676',
    fontFamilyHeadline: FontFamily.OpenSans,
    fontFamilyPrimary: FontFamily.OpenSans,
    fontFamilySecondary: FontFamily.OpenSans,
    fontSizeBase: '16px',
    ctaStyles: {},
    errorStyles: {},
    headlineStyles: { fontFamily: FontFamily.OpenSans },
    labelStyles: {},
};
exports.DefaultEvenTheme = Object.assign(Object.assign({}, DefaultTheme), { backdropStyles: { backgroundColor: '#f5f9ff', padding: '16px 10px 0 10px' }, colorBackgroundPrimary: ThemeColor.gray3, colorBackgroundSecondary: ThemeColor.white, colorBorder: ThemeColor.gray5, colorCta: ThemeColor.green, colorError: ThemeColor.red, colorPrimary: ThemeColor.blue, colorSecondary: ThemeColor.blue, colorTextPrimary: ThemeColor.gray9, colorTextSecondary: ThemeColor.gray7, partnerLogo: 'https://images.evenfinancial.com/logos/even_logo-solo-black.png', ctaStyles: { backgroundColor: ThemeColor.green }, errorStyles: { color: ThemeColor.red } });
exports.DefaultFionaTheme = Object.assign(Object.assign({}, DefaultTheme), { backdropStyles: { backgroundColor: '#f8f2ff', padding: '16px 10px 0 10px' }, colorBackgroundSecondary: '#f4f4f4', colorCta: '#14e075', colorError: '#ff7200', colorPrimary: '#3b1c5a', colorSecondary: '#ff7200', fontFamilyHeadline: FontFamily.Nunito, fontFamilyPrimary: FontFamily.Nunito, fontFamilySecondary: FontFamily.Nunito, partnerLogo: 'https://images.evenfinancial.com/logos/fiona/fiona-wordmark.svg', ctaStyles: { backgroundColor: '#14e075' }, errorStyles: { color: '#ff7200' }, headlineStyles: { fontFamily: FontFamily.Nunito } });
exports.DefaultLeapLifeTheme = Object.assign(Object.assign({}, DefaultTheme), { backdropStyles: { backgroundColor: ThemeColor.white, padding: '16px 10px 0 10px' }, borderRadiusLarge: '8px', borderRadiusSmall: '6px', colorBackgroundSecondary: ThemeColor.white, colorBorder: '#e4e5e7', colorCta: '#0CA678', colorError: '#ff7200', colorPrimary: '#0082c8', colorSecondary: '#2B3A48', fontFamilyHeadline: exports.LeapLifeDefaultFonts.Nunito, fontFamilyPrimary: exports.LeapLifeDefaultFonts.Nunito, fontFamilySecondary: exports.LeapLifeDefaultFonts.Roboto, partnerLogo: 'https://images.evenfinancial.com/logos/leaplife/leap-logo-green.svg', ctaStyles: { backgroundColor: '#0CA678', borderRadius: '24px' }, errorStyles: { color: '#ff7200' }, headlineStyles: { fontFamily: exports.LeapLifeDefaultFonts.Nunito } });
exports.EmptyThemeParameterMap = {
    'backdropStyles.backgroundColor': 'colorBackgroundSecondary',
    'backdropStyles.borderColor': 'colorBorder',
    'headlineStyles.fontFamily': 'fontFamilyPrimary',
    'labelStyles.fontFamily': 'fontFamilySecondary',
};
// map deprecated params to new params
// to be removed after backfill
exports.DeprecatedThemeParameterMap = {
    ctaStyles: {
        backgroundColor: 'colorCta',
        fontFamily: 'fontFamilyCTA',
        letterSpacing: 'letterSpacingCTA',
    },
    errorStyles: {
        color: 'colorError',
    },
    headlineStyles: {
        fontFamily: 'fontFamilyHeadline',
    },
    labelStyles: {
        fontFamily: 'fontFamilyLabels',
        letterSpacing: 'letterSpacingLabels',
    },
};
//# sourceMappingURL=theme.js.map